(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cabeza-destacada-slideshow"] && !Shopify.designMode) return;
  try {
    
  function initArtistHeroSlideshow(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var track = root.querySelector('.artist-hero-slideshow__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.artist-hero-slide'));
    var prevBtn = root.querySelector('.artist-hero-slideshow__arrow--prev');
    var nextBtn = root.querySelector('.artist-hero-slideshow__arrow--next');
    var dotsWrap = root.querySelector('.artist-hero-slideshow__dots');
    var autoplaySeconds = parseFloat(root.dataset.autoplaySeconds) || 5;
    var total = slides.length;
    var index = 0;
    var timer = null;

    if (total === 0 || !track || !prevBtn || !nextBtn) return;

    function buildDots() {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < total; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'dot' + (i === index ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Ir al slide ' + (i + 1));
        dot.addEventListener('click', function (e) {
          goTo(Array.prototype.indexOf.call(dotsWrap.children, e.currentTarget));
          resetAutoplay();
        });
        dotsWrap.appendChild(dot);
      }
    }

    function render() {
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function goTo(i) {
      if (i < 0) i = total - 1;
      if (i > total - 1) i = 0;
      index = i;
      render();
    }

    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }

    function startAutoplay() {
      clearInterval(timer);
      if (autoplaySeconds <= 0) return;
      timer = setInterval(next, autoplaySeconds * 1000);
    }

    function resetAutoplay() {
      startAutoplay();
    }

    prevBtn.addEventListener('click', function (e) {
      e.preventDefault();
      prev();
      resetAutoplay();
    });
    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      next();
      resetAutoplay();
    });

    buildDots();
    render();
    startAutoplay();
  }

  function initAllArtistHeroSlideshows() {
    document.querySelectorAll('.artist-hero-slideshow').forEach(initArtistHeroSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllArtistHeroSlideshows);
  } else {
    initAllArtistHeroSlideshows();
  }

  // Reinicializa si el editor de temas de Shopify vuelve a cargar la sección
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.artist-hero-slideshow');
    if (root) {
      root.dataset.initialized = 'false';
      initArtistHeroSlideshow(root);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
